import { render, staticRenderFns } from "./TeachAndExamTime.vue?vue&type=template&id=64801f20"
import script from "./TeachAndExamTime.vue?vue&type=script&lang=js"
export * from "./TeachAndExamTime.vue?vue&type=script&lang=js"
import style0 from "./TeachAndExamTime.vue?vue&type=style&index=0&id=64801f20&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports